import { z } from 'zod';
import { PasswordSchema } from './password.js';
/**
 * Cambiar la contraseña **con la sesión abierta**. Es otra cosa que la recuperación por email
 * (`password-reset.ts`), que arranca sin sesión y se identifica con un código de 6 dígitos.
 *
 * Se pide la actual aunque el token ya pruebe quién es: una sesión abierta en una máquina
 * compartida no debería alcanzar para dejar afuera al dueño de la cuenta.
 */
export const ChangePasswordRequest = z
    .object({
    passwordActual: PasswordSchema,
    passwordNueva: PasswordSchema,
})
    .strict()
    .refine((v) => v.passwordActual !== v.passwordNueva, {
    message: 'La contraseña nueva tiene que ser distinta de la actual',
    path: ['passwordNueva'],
});
/**
 * Devuelve un access token nuevo, igual que el login.
 *
 * No es un detalle: el cambio escribe `passwordChangedAt`, y el refresh rechaza todo token
 * emitido antes de esa marca. Sin reemitir el par, quien acaba de cambiar la contraseña se
 * quedaría con un refresh muerto y a los 15 minutos lo escupiría al login.
 */
export const ChangePasswordResponse = z.object({ accessToken: z.string() }).strict();
